export enum PortalRootId {
    modalRoot = 'modalRoot',
    portalRoot = 'portalRoot',
    contractPortalRoot = 'contractPortalRoot',
    cameraPreviewRoot = 'cameraPreviewRoot',
    inquiryFormPortal = 'inquiryFormPortal',
}
